<template>
  <el-breadcrumb :separator-icon="ArrowRight" style="margin-bottom: 16px;">
    <template v-for="(item, index) in breadcrumbList" :key="index">
      <el-breadcrumb-item :to="{ path: item.path }" v-if="item.path">{{item.label}}</el-breadcrumb-item>
      <el-breadcrumb-item v-else>{{item.label}}</el-breadcrumb-item>
    </template>
  </el-breadcrumb>
</template>

<script setup>
import { ref, watch, onMounted } from 'vue'
import { ArrowRight } from '@element-plus/icons-vue'
import { useRoute } from 'vue-router'
import { menuList } from '@/assets/menuList'

const route = useRoute()
const breadcrumbList = ref([])

const baseCrumb = [{ label: '首页', path: '/' }]

const detailBreadcrumbMap = {
  dashboard: { parentPath: '/dashboard', label: '概况' },
  productDetail: { parentPath: '/product/list', label: '商品详情' },
  orderDetail: { parentPath: '/order/list', label: '订单详情' },
  agentDetail: { parentPath: '/agent/list', label: '城市服务商详情' },
  distributorDetail: { parentPath: '/distributor/list', label: '分销商详情' },
  hospitalDetail: { parentPath: '/hospital/list', label: '医院详情' },
  doctorDetail: { parentPath: '/doctor/list', label: '医生详情' },
  distributorBillDetail: { parentPath: '/distributor/list', label: '分销商账单明细' },
  dealerBillDetail: { parentPath: '/agent/list', label: '城市服务商账单明细' },
  hospitalBillDetail: { parentPath: '/hospital/list', label: '医院账单明细' },
  hospitalFreeCaseApplyDetail: { parentPath: '/hospital/free/case/apply/list', label: '公益案例详情' },
}

const findMenuByPath = (path) => {
  for (const top of menuList) {
    if (top.path === path) {
      return {
        sectionTitle: top.title,
        itemTitle: top.title,
        itemPath: top.path,
      }
    }
    const children = top.children || []
    const hit = children.find((child) => child.path === path)
    if (hit) {
      return {
        sectionTitle: top.title,
        itemTitle: hit.title,
        itemPath: hit.path,
      }
    }
  }
  return null
}

const buildCrumbsFromMenuPath = (path) => {
  const menuNode = findMenuByPath(path)
  if (!menuNode) return null
  return [...baseCrumb, { label: menuNode.sectionTitle }, { label: menuNode.itemTitle, path: menuNode.itemPath }]
}

const init = () => {
  const direct = buildCrumbsFromMenuPath(route.path)
  if (direct) {
    breadcrumbList.value = direct
    return
  }

  const detail = detailBreadcrumbMap[route.name || '']
  if (detail) {
    const parent = findMenuByPath(detail.parentPath)
    if (parent) {
      breadcrumbList.value = [
        ...baseCrumb,
        { label: parent.sectionTitle },
        { label: parent.itemTitle, path: parent.itemPath },
        { label: detail.label },
      ]
      return
    }
  }

  const routeTitle = String(route.meta?.title || route.name || '页面')
  breadcrumbList.value = [...baseCrumb, { label: routeTitle }]
}

onMounted(() => {
  init()
})

watch(
  () => [route.path, route.name],
  () => {
    init()
  },
)
</script>

<style scoped lang="less">
  @import "index.less";
</style>
